export const formatter = (amount, locales = 'en-US', currency = 'USD') => {
  return new Intl.NumberFormat(locales, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  }).format(convertCentToDollar(amount))
};

export const formatterBalance = (amount, currency = 'USD') => {
  return formatter(amount, 'en-US', currency);
};

export const convertCentToDollar = (price) => {
  return (Math.round(price) / 100).toFixed(2);
}
